import { Route, RouterModule } from '@angular/router';
import { Login } from './features/components/login/login';
import { Home } from './features/components/home/home';
import { NgModule } from '@angular/core';
import { AuthGuard } from './core/guards/auth.guard';
import { NotAllowed } from './features/components/not-allowed/not-allowed';
import { GroupGuard } from './core/guards/group.guard';
import { GroupList } from './features/pages/group/group-list/group-list';
import { ProfileList } from './features/pages/profile/profile-list/profile-list';
import { ProfileForm } from './features/pages/profile/profile-form/profile-form';
import { LineList } from './features/pages/line/line-list/line-list';
import { LineForm } from './features/pages/line/line-form/line-form';
import { ChangePassword } from './features/components/change-password/change-password';
import { ComponentForm } from './features/pages/component/component-form/component-form';
import { ComponentList } from './features/pages/component/component-list/component-list';
import { SectorForm } from './features/pages/sector/sector-form/sector-form';
import { SectorList } from './features/pages/sector/sector-list/sector-list';
import { LocationForm } from './features/pages/location/location-form/location-form';
import { LocationList } from './features/pages/location/location-list/location-list';
import { AddressForm } from './features/pages/address/address-form/address-form';
import { AddressList } from './features/pages/address/address-list/address-list';
import { ExpensesForm } from './features/pages/expenses/expenses-form/expenses-form';
import { ExpensesList } from './features/pages/expenses/expenses-list/expenses-list';
import { SourcefoundingList } from './features/pages/sourcefounding/sourcefounding-list/sourcefounding-list';
import { SourcefoundingForm } from './features/pages/sourcefounding/sourcefounding-form/sourcefounding-form';
import { FixedassetList } from './features/pages/fixedasset/fixedasset-list/fixedasset-list';
import { FixedassetForm } from './features/pages/fixedasset/fixedasset-form/fixedasset-form';
import { ConsumableassetForm } from './features/pages/consumableasset/consumableasset-form/consumableasset-form';
import { ConsumableassetList } from './features/pages/consumableasset/consumableasset-list/consumableasset-list';
import { InfraestructureForm } from './features/pages/infraestructure/infraestructure-form/infraestructure-form';
import { InfraestructureList } from './features/pages/infraestructure/infraestructure-list/infraestructure-list';
import { EmployeeForm } from './features/pages/employee/employee-form/employee-form';
import { EmployeeList } from './features/pages/employee/employee-list/employee-list';
import { ServiceactivityList } from './features/pages/serviceactivity/serviceactivity-list/serviceactivity-list';
import { ServiceactivityForm } from './features/pages/serviceactivity/serviceactivity-form/serviceactivity-form';
import { AssistanceserviceList } from './features/pages/assistanceservice/assistanceservice-list/assistanceservice-list';
import { AssistanceserviceForm } from './features/pages/assistanceservice/assistanceservice-form/assistanceservice-form';
import { AssistanceList } from './features/pages/assistance/assistance-list/assistance-list';
import { AssistanceForm } from './features/pages/assistance/assistance-form/assistance-form';
import { AssistanceAssistanceserviceList } from './features/pages/assistanceservice/assistance-assistanceservice-list/assistance-assistanceservice-list';
import { AssistanceserviceServiceactivityList } from './features/pages/serviceactivity/assistanceservice-serviceactivity-list/assistanceservice-serviceactivity-list';
import { TermKey } from './core/models/terminology.interface';
import { TerritoryList } from './features/pages/territory/territory-list/territory-list';
import { TerritoryForm } from './features/pages/territory/territory-form/territory-form';
import { LifeplanList } from './features/pages/lifeplan/lifeplan-list/lifeplan-list';
import { LifeplanForm } from './features/pages/lifeplan/lifeplan-form/lifeplan-form';
import { ChangelogList } from './features/pages/changelog/changelogs-list/changelog-list';

export type DataComponent = {
  protected: boolean;
  parent: string | null;
  isModule: boolean;
  public: boolean;
  icon?: string;
  menuText?: string;
  key?: string;
};

export type CustomRoute = Route & { data: DataComponent };

export const routes: CustomRoute[] = [
  {
    path: 'login',
    component: Login,
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: true,
    },
  },
  {
    path: 'home',
    component: Home,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: true,
      icon: 'home',
      menuText: 'Inicio',
    },
  },
  {
    path: 'groups',
    component: GroupList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'groups',
      menuText: 'Grupos',
    },
  },

  {
    path: 'profile',
    component: ProfileForm,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },
  {
    path: 'profile-list',
    component: ProfileList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'person',
      menuText: 'Perfiles',
      key: TermKey.profilesPlural,
    },
  },

  {
    path: 'line',
    component: LineForm,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },

  {
    path: 'line-list',
    component: LineList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'linear_scale',
      menuText: 'Líneas',
    },
  },

  {
    path: 'component',
    component: ComponentForm,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },

  {
    path: 'component-list',
    component: ComponentList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'category',
      menuText: 'Componentes',
    },
  },

  {
    path: 'sector',
    component: SectorForm,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },

  {
    path: 'sector-list',
    component: SectorList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'domain',
      menuText: 'Tejidos',
      key: TermKey.SectorPlural,
    },
  },

  {
    path: 'location',
    component: LocationForm,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },

  {
    path: 'location-list',
    component: LocationList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'location_on',
      menuText: 'Ubicaciones',
    },
  },

    {
    path: 'lifeplan',
    component: LifeplanForm,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },

  {
    path: 'lifeplan-list',
    component: LifeplanList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'psychology',
      menuText: 'Planes de vida',
    },
  },

  {
    path: 'territory',
    component: TerritoryForm,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },

  {
    path: 'territory-list',
    component: TerritoryList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'public',
      menuText: 'Territorios',
    },
  },

  {
    path: 'address',
    component: AddressForm,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },

  {
    path: 'address-list',
    component: AddressList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'directions',
      menuText: 'Direcciones',
    },
  },

  {
    path: 'expense',
    component: ExpensesForm,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },

  {
    path: 'expense-list',
    component: ExpensesList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'receipt_long',
      menuText: 'Gastos',
    },
  },

  {
    path: 'sourcefounding',
    component: SourcefoundingForm,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },

  {
    path: 'sourcefounding-list',
    component: SourcefoundingList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'account_balance',
      menuText: 'Fuentes de financiación',
    },
  },

  {
    path: 'employee',
    component: EmployeeForm,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },

  {
    path: 'employee-list',
    component: EmployeeList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'person',
      menuText: 'Cargos',
    },
  },

  {
    path: 'serviceactivity',
    component: ServiceactivityForm,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },

  {
    path: 'serviceactivity-list',
    component: ServiceactivityList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'build',
      menuText: 'Actividades del servicio',
      key: TermKey.ActivityServicePlural,
    },
  },

  {
    path: 'assistanceservice',
    component: AssistanceserviceForm,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },

  {
    path: 'assistanceservice-list',
    component: AssistanceserviceList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'support_agent',
      menuText: 'Servicios de asistencia',
      key: TermKey.AccompanimentServicePlural,
    },
  },

  {
    path: 'assistance',
    component: AssistanceForm,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },

  {
    path: 'assistance-list',
    component: AssistanceList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'support',
      menuText: 'Asistencias',
      key: TermKey.AssistancePlural,
    },
  },

  {
    path: 'change-password',
    component: ChangePassword,
    canActivate: [AuthGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },

  {
    path: 'fixedasset',
    component: FixedassetForm,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },

  {
    path: 'fixedasset-list',
    component: FixedassetList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'inventory_2',
      menuText: 'Activos fijos',
      key: TermKey.FixedAssetPlural,
    },
  },

  {
    path: 'consumableasset',
    component: ConsumableassetForm,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },

  {
    path: 'consumableasset-list',
    component: ConsumableassetList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'build_circle',
      menuText: 'Activos consumibles',
      key: TermKey.ConsumableAssetPlural,
    },
  },

  {
    path: 'infraestructure',
    component: InfraestructureForm,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },

  {
    path: 'infraestructure-list',
    component: InfraestructureList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'apartment',
      menuText: 'Infraestructura',
    },
  },

  {
    path: 'assistance-assistanceservice/:id',
    component: AssistanceAssistanceserviceList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },

  {
    path: 'assistanceservice-serviceactivity/:id',
    component: AssistanceserviceServiceactivityList,
    canActivate: [AuthGuard, GroupGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },
  {
    path: 'changelog-list',
    component: ChangelogList,
    canActivate: [AuthGuard, GroupGuard],
    data:{
      protected: false,
      parent: null,
      isModule: true,
      public: false,
      icon: 'history',
      menuText: 'Lista de Versiones',      
    }
  },
  {
    path: 'not-allowed',
    component: NotAllowed,
    canActivate: [AuthGuard],
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: false,
    },
  },
  {
    path: '**',
    redirectTo: 'login',
    data: {
      protected: false,
      parent: null,
      isModule: false,
      public: true,
    },
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
export const routeList = routes;
